import { DashboardComponentGroupReportOptions } from "./DashboardReportOptions";

export enum DashboardLayoutType {
  VERTICAL = "VERTICAL",
  HORIZONTAL_FLEX = "HORIZONTAL_FLEX",
  GRID = "GRID",
}
export type LayoutConfigType = {
  [DashboardLayoutType.VERTICAL]?: {
    width?: number;
    height?: number | string;
  };
  [DashboardLayoutType.HORIZONTAL_FLEX]?: {
    width?: number;
    height?: number | string;
  };
  [DashboardLayoutType.GRID]?: {
    width?: number;
    height?: number | string;
    x: number;
    y: number;
  };
};

export interface IDashboardComponent {
  id: string;
  title: string;
  titleSize: string;
  titleAlign: string;
  type: string;
  config: any;
  layout: LayoutConfigType;
  collapsable: boolean;
  defaultCollapsed?: boolean;
  hideHeader?: boolean;
  reportOptions?: DashboardComponentGroupReportOptions;
}

export interface OldDashboardComponent {
  TYPE: string;
  id: string;
  width: number;
  title: string;
  componentType: string;
  jsonConfig: string;
}
